export const EVENT_LABELS = {
  PROJECTED_RETREAT_CREATED: "Projected retreat created",
  RETREAT_SUB_ADMIN_ASSIGNED: "Retreat sub-admin assigned",
  RETREAT_SUB_ADMIN_REMOVED: "Retreat sub-admin removed",
  LEAD_COUPLE_ASSIGNED: "Lead couple assigned",
  LEAD_COUPLE_CHANGED: "Lead couple changed",
  LEAD_COUPLE_REMOVED: "Lead couple removed",
  CO_LEAD_COUPLE_ASSIGNED: "Co-lead couple assigned",
  CO_LEAD_COUPLE_CHANGED: "Co-lead couple changed",
  CO_LEAD_COUPLE_REMOVED: "Co-lead couple removed",
  MENTOR_COUPLE_ASSIGNED: "Mentor couple assigned",
  MENTOR_COUPLE_CHANGED: "Mentor couple changed",
  MENTOR_COUPLE_REMOVED: "Mentor couple removed",
  COMMITTEE_MEMBER_ASSIGNED: "Committee member assigned",
  COMMITTEE_MEMBER_REMOVED: "Committee member removed",
  LEAD_COUPLE_ACCESS_GRANTED: "Lead couple access granted",
  LEAD_COUPLE_ACCESS_CHANGED: "Lead couple access changed",
  LEAD_COUPLE_ACCESS_REMOVED: "Lead couple access removed",
  RETREAT_SETUP_STARTED: "Retreat setup started",
  STATUS_CHANGED: "Status changed",
  NOTIFICATION_SENT: "Notification sent",
  PUBLICATION_APPROVED: "Publication approved",
  PUBLICATION_CHANGES_REQUESTED: "Publication changes requested",
  POST_RETREAT_CLOSING_APPROVED: "Post-retreat closing approved",
  RETREAT_CLOSED: "Retreat closed",
  RETREAT_DELETED: "Retreat deleted",
  RETREAT_RESTORED: "Retreat restored",
  READY_FOR_APPROVAL: "Ready for approval",
  USER_LOGIN: "Logged in",
  USER_LOGOUT: "Logged out",
  COUPLE_REGISTERED: "Couple registered",
  ROSTER_COUPLE_ADDED: "Couple added to Roster",
  ROSTER_COUPLE_UPDATED: "Roster couple updated",
  ROSTER_ENTRY_REMOVED: "Roster entry removed",
  ROSTER_IMPORT: "Roster Excel imported",
  ROSTER_TALK_ASSIGNED: "Roster talk assigned",
  ROSTER_TALK_REMOVED: "Roster talk removed",
  DIRECTORY_HEADER_IMAGE_UPLOADED: "Directory header image uploaded",
  DIRECTORY_HEADER_IMAGE_REMOVED: "Directory header image removed",
  DIRECTORY_FOOTER_IMAGE_UPLOADED: "Directory footer image uploaded",
  DIRECTORY_FOOTER_IMAGE_REMOVED: "Directory footer image removed",
  DIRECTORY_FOOTER_TEXT_UPDATED: "Directory footer text updated",
  DIRECTORY_SCANNER_IMAGE_UPLOADED: "Directory scanner image uploaded",
  DIRECTORY_SCANNER_IMAGE_REMOVED: "Directory scanner image removed",
  DIRECTORY_LINKS_UPDATED: "Directory social links updated",
  DIRECTORY_PUBLISHED: "Directory published",
  DIRECTORY_UNPUBLISHED: "Directory unpublished",
  DIRECTORY_PDF_UPLOADED: "Directory PDF uploaded",
  DIRECTORY_PDF_REMOVED: "Directory PDF removed",
  PROGRAM_PDF_UPLOADED: "Program PDF uploaded",
  PROGRAM_PDF_REMOVED: "Program PDF removed",
  ROSTER_DIR_PROG_FILE_UPLOADED: "Directory/Program file uploaded",
  ROSTER_FILE_REMOVED: "Roster file removed",
  PROGRAM_HEADER_IMAGE_UPLOADED: "Program header image uploaded",
  PROGRAM_HEADER_IMAGE_REMOVED: "Program header image removed",
  PROGRAM_FOOTER_IMAGE_UPLOADED: "Program footer image uploaded",
  PROGRAM_FOOTER_IMAGE_REMOVED: "Program footer image removed",
  PROGRAM_QR_IMAGE_UPLOADED: "Program QR image uploaded",
  PROGRAM_QR_IMAGE_REMOVED: "Program QR image removed",
  PROGRAM_PAGE_CONTENT_UPDATED: "Program page content updated",
  PROGRAM_TALK_CONTENT_UPDATED: "Program talk content updated",
  PROGRAM_ENDING_COLOR_UPDATED: "Program back cover color updated",
  PROGRAM_SPEAKER_ADDED: "Program speaker added",
  PROGRAM_TEAM_ROLE_ASSIGNED: "Program team role assigned",
  PROGRAM_SERVICE_ASSIGNED: "Program service assigned",
  PROGRAM_TEAM_MEMBER_REMOVED: "Program team member removed",
  PROGRAM_PUBLISHED: "Program published",
  PROGRAM_UNPUBLISHED: "Program unpublished",
};
